/* eslint-disable react-hooks/exhaustive-deps */
import { Select, Form, Button } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './VintageItemForm.module.scss'
import React, { useEffect, useState } from 'react'
import { VintageItemPayload } from 'src/core/models'
import { getVintageAvailableYears } from 'src/core/helpers'
import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  CustomInputDecimal,
  CustomInputNumber,
  CustomDatePicker,
  CustomSelect,
  CustomText,
} from 'src/components'
import {
  projectDetailsSelector,
  setProjectFormItemValue,
  projectFormStateSelector,
} from 'src/features'
import moment from 'moment'

const VintageItemForm: React.FC = () => {
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [years, setYears] = useState([])
  const { vintage_items, kind, currentVintage } = useAppSelector(projectFormStateSelector)
  const { project: projectToEdit } = useAppSelector(projectDetailsSelector)
  const isYearDisabled: boolean = (
    currentVintage?.year &&
    Boolean(projectToEdit?.vintage_items.find(vi => vi.year === currentVintage.year))
  )

  const onFinish = (values: VintageItemPayload) => {
    let newList: VintageItemPayload[] = []
    newList = [...vintage_items, { ...values, year: +values.year }]

    if (currentVintage) {
      newList = vintage_items.map(vintage => {
        if (vintage.year !== currentVintage.year) { return vintage }
        return {
          year: +values.year,
          stock: values.stock,
          price: values.price,
          delivery_date: values.delivery_date
        }
      })
      dispatch(setProjectFormItemValue({ key: 'currentVintage', value: null }))
    }
    dispatch(setProjectFormItemValue({ key: 'vintage_items', value: newList }))
    form.resetFields()
  }

  useEffect(() => {
    setYears(getVintageAvailableYears(vintage_items, kind))
  }, [vintage_items, kind])

  useEffect(() => {
    if (currentVintage) {
      const currentDate = currentVintage.delivery_date || null
      form.setFieldsValue({
        ['year']: currentVintage.year,
        ['price']: currentVintage.price,
        ['stock']: currentVintage.stock,
        ['delivery_date']: currentDate && typeof currentDate === 'string' ?  moment(new Date(currentDate)) : currentDate
      })
    } else { form.resetFields() }
  }, [currentVintage])

  return (
    <Form
      onFinish={onFinish}
      form={form}
    >
      <div className={styles.content}>
        {/* Year */}
        <div className={styles.YearSelector}>
          <CustomText label={t('Projects.Year')} type='secondary' />
          <CustomSelect
            name='year'
            placeholder={t('Projects.YearPlaceholder')}
            disabled={isYearDisabled}
            required
          >
            {years.map(year => <Select.Option key={year}>{year}</Select.Option>)}
          </CustomSelect>
        </div>

        {/* Pirce */}
        <div>
          <CustomText label={t('Projects.Price')} type='secondary' />
          <CustomInputDecimal
            name='price'
            placeholder={t('Projects.PricePlaceHolder')}
            required
          />
        </div>

        {/* Stock */}
        <div>
          <CustomText label={t('Projects.Stock')} type='secondary' />
          <CustomInputNumber
            name='stock'
            placeholder={t('admin.Brokerage.StockPlaceHolder')}
            required
          />
        </div>

        {/* Delivery Date */}
        {kind === 'carbon_forward' && (
          <div className={styles.DeliveryDate}>
            <CustomText label={t('Forward.DeliveryDate')} type='secondary' />
            <CustomDatePicker
              name='delivery_date'
              placeholder={t('Forward.DeliveryDatePlaceholder')}
              required
            />
          </div>
        )}

        {/* Submit Button */}
        <div className={styles.SubmitButtonContent}>
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            className={styles.submitButton}
            icon={currentVintage ? <EditOutlined /> : <PlusOutlined />}
          >
            {currentVintage ? t('Projects.Confirmchanges') : t('Projects.Addvintage')}
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default VintageItemForm
